import styled from '@emotion/styled';
import { css, Flex } from 'theme-ui';
import { DetailPageTitle } from '../../shared-styled/typography/titles';

export const WhatsNewWrapper = styled(Flex)(
  css({
    py: '92px',
    justifyContent: 'center',
  }),
);

export const WhatsNewContainer = styled(Flex)(
  css({
    flexDirection: 'column',
    width: ['100%', '100%', '60%'],
    px: ['40px', '50px', 0],
  }),
);

export const WhatsNewTitle = styled(DetailPageTitle)(
  css({
    width: '100%',
    textAlign: 'center',
    mb: '65px',
  }),
);

export const ContentContainer = styled(Flex)(
  css({
    flexDirection: 'column',
    gap: '30px',
    mb: '30px',
  }),
);

export const Author = styled.p(
  css({
    textTransform: 'capitalize',
    mt: '36px',
  }),
);
